import * as React from 'react';

// #region Component Props

interface IProps {
    id          : string;
    text        : string;
    child?      : any;
    onBtnClick  : any;
    icon?       : string;
    classes?    : string;
    disable?    : boolean;
}

// #endregion

const FlatButton : React.SFC<IProps> = (props) => {

    const { id, icon, text, onBtnClick, classes, disable } = props;
    const hasIcon = icon ?  true : false;
    const classList = hasIcon ? 'btn-icon ' + classes : 'btn-flat ' + classes;

    return <button 
            id={ id }
            className={ classList }
            disabled={ disable }
            onClick={ onBtnClick } >
                { 
                    hasIcon 
                        ? <i className={ `la ${ icon }` } />
                        : null
                }
                { props.child === undefined ? text : props.child }
            </button>;
};

FlatButton.defaultProps = {
    icon: '',
    classes: '',
    disable: false,
    child: undefined
};

export { FlatButton };
